<div style="display: flex; flex-direction: row-reverse">
  <div
    class="sidebar"
    [ngClass]="{
      'full-width-container2': !showDetailSection,
      'half-width-container2': showDetailSection
    }"
    style="overflow: auto"
  >
    <div class="sidebar-title">
      <div class="sidebar-title-text">RFQ Details</div>
    </div>

    <div class="sidebar-content">

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
          >Buyer Company Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Buyer Name : {{ headerData?.buyerCompanyName }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.companyEmailId }}
            </li>
            <li class="list-group-item">
              Phone : {{ headerData?.companyPhoneNumber }}
            </li>
            <li class="list-group-item">Fax : {{ headerData?.companyFax }}</li>
            <li class="list-group-item">
              Address : {{ headerData?.companyAddress }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Buyer Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">Contact : {{ headerData?.contact }}</li>
            <li class="list-group-item">
              Job Title : {{ headerData?.jobTitle }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.emailId }}
            </li>
            <li class="list-group-item">Phone : {{ headerData?.phone }}</li>
            <li class="list-group-item">Fax : {{ headerData?.fax }}</li>
            <li class="list-group-item">Address : {{ headerData?.address }}</li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          RFQ Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              RFQ Ref Number : {{ headerData?.rfqRefNumber }}
            </li>
            <li class="list-group-item">
              RFQ Date : {{ headerData?.rfqDate | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Quote by Date :
              {{ headerData?.quoteByDate | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Document Number : {{ headerData?.docNumber }}
            </li>
            <li class="list-group-item">
              Tracking Number : {{ headerData?.trackingNumber }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            padding-bottom: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Vessel Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Vessel Name : {{ headerData?.vessel?.vesselName }}
            </li>
            <li class="list-group-item">
              Vessel IMO Number : {{ headerData?.vessel?.imoNumber }}
            </li>
            <li class="list-group-item">
              Vessel Type : {{ headerData?.vessel?.typeOfVessel }}
            </li>
            <li class="list-group-item">
              Class : {{ headerData?.vessel?.class }}
            </li>
            <li class="list-group-item">
                Hull Number : {{ headerData?.vessel?.hullNumber }}
            </li>
            <li class="list-group-item">
              Yard Name : {{ headerData?.vessel?.yardName }}
            </li>
            <li class="list-group-item">
              Year Built : {{ headerData?.vessel?.yearBuilt }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            padding-bottom: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Port Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Port Name : {{ headerData?.portName }}
            </li>
            <li class="list-group-item">
              Port Code : {{ headerData?.portCode }}
            </li>
            <li class="list-group-item">
              Vessel ETA : {{ headerData?.vesselEta | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Vessel ETD : {{ headerData?.vesselEtd | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
                Vessel ETB : {{ headerData?.vesselEtb | date : "dd/MM/yyyy" }}
            </li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Port Agent Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Port Agency Name : {{ headerData?.portAgentNumber }}
            </li>
            <li class="list-group-item">
              Port Agent Name : {{ headerData?.portAgentNumber }}
            </li>
            <li class="list-group-item">
              Port Agent Phone Number : {{ headerData?.rfqPortAgentphone }}
            </li>
            <li class="list-group-item">
              Port Agent Contact : {{ headerData?.rfqPortAgentContact }}
            </li>
            <li class="list-group-item">
              Port Agent Fax : {{ headerData?.rfqPortAgentfax }}
            </li>
            <li class="list-group-item">
              Port Agent Email Id : {{ headerData?.rfqPortAgentemailId }}
            </li>
            <li class="list-group-item">
              Address : {{ headerData?.rfqPortAgentaddress }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Freight Forwarder Details - Removed from service flow -->

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Delivery Details
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Request Delivery Date :
              {{ headerData?.requestDeliveryDate | date : "dd/MM/yyyy" }}
            </li>
            <li class="list-group-item">
              Lead Time In Delivery : {{ headerData?.leadTimeInDelivery }}
            </li>
            <li class="list-group-item">
              Contact : {{ headerData?.Deliverycontact }}
            </li>
            <li class="list-group-item">
              Email Id : {{ headerData?.Deliveryemail }}
            </li>
            <li class="list-group-item">
              Phone : {{ headerData?.Deliverycontact }}
            </li>
            <li class="list-group-item">Fax : {{ headerData?.Deliveryfax }}</li>
            <li class="list-group-item">
              Delivery Terms And Conditions :
              {{ headerData?.deliveryTermsAndConditions }}
            </li>
            <li class="list-group-item">
              Delivery Address : {{ headerData?.deliveryAddress }}
            </li>
            <li class="list-group-item">Mode of Transport : {{ headerData?.modeOfTransport || 'N/A' }}</li>
          </ul>
        </div>
      </div>

      <div class="header-form">
        <span
          style="
            padding-left: 16px;
            padding-top: 16px;
            margin-bottom: 16px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          "
        >
          Invoice Address
        </span>

        <div>
          <ul class="list-group">
            <li class="list-group-item">
              Buyer Name : {{ headerData?.buyerCompanyName }}
            </li>
            <li class="list-group-item">Email Id : {{ headerData?.emailId }}</li>
            <li class="list-group-item">
              Phone : {{ headerData?.companyPhoneNumber }}
            </li>
            <li class="list-group-item">Fax : {{ headerData?.fax }}</li>
            <li class="list-group-item">
              Address : {{ headerData?.invoiceAddress }}
            </li>
          </ul>
        </div>
      </div>

     <div class="header-form">
        <div class="header-title">Buyer Payment Terms</div>
        <div class="header-content">
          {{ headerData?.buyerPaymentTerms }}
        </div>
      </div>

      <div class="header-form">
        <div class="header-title">Buyer Terms & Conditions</div>
        <div class="header-content pre-line">
          {{ headerData?.buyerTermsAndCondition }}
        </div>
      </div>

    </div>
  </div>

  <div
    class="rfq-create-form"
    [ngClass]="{
      'full-width-container1': !showDetailSection,
      'half-width-container1': showDetailSection
    }"
  >
    <div class="rfq-create-form-title">
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        "
      >
        <div id="createquotation" style="flex: 1">Create Quotation</div>
        <div
          style="
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            padding: 10px;
            justify-content: flex-end;
            flex: 3;
            background-color: white;
          "
        >
          <button
            class="right-button"
            (click)="toggleShowHeaderDetails({ checked: !showDetailSection })"
          >
            {{ showDetailSection ? "Hide RFQ Details" : "Show RFQ Details" }}
          </button>
        </div>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          margin-top: 10px;
          margin-bottom: 5px;
        "
      >
        <button
          mat-button
          color="primary"
          style="
            font-size: 18px;
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 24px;
            padding-bottom: 24px;
          "
          (click)="close(true)"
        >
          Close<mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </div>

    <div
      class="col-xl-10 col-lg-9 col-9 p-0 card-body-fixheight z-index-4"
      style="width: 100%"
    >
      <mat-card class="p-0" style="margin: 0 0.5rem">
        <mat-card-content class="ship-fscoll hgt ship-pr-sec">
          <nav mat-tab-nav-bar class="tagGroup">
            <a
              mat-tab-link
              *ngFor="let tabItem of tabs; let idx = index"
              [class.active-link]="currentTab === tabItem.route"
              class="teb_icon"
              (click)="selectMatTabLink(tabItem)"
            >
              <span id="navstepstext">{{ tabItem.label }}</span>
            </a>
          </nav>

          <div class="mat-tab-body-content pos-relative">
            <div>
              <form [formGroup]="firstFormGroup">
                <div>
                  <div class="header-form">
                    <span
                      style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      "
                      (click)="toggleVisibility('form1')"
                    >
                      Quotation Details
                      <mat-icon>
                        {{ isForm1Expand ? "minimize" : "add" }}
                      </mat-icon>
                    </span>

                    <div *ngIf="isForm1Expand" class="three-column-flex">
                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Quote Ref Number</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="quoteRefNumber"
                            readonly
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Quotation date</mat-label>
                          <input
                            matInput
                            name="quoteDate"
                            formControlName="quoteDate"
                            [matDatepicker]="quotedDateDatepicker"
                            [min]="minDate"
                            [max]="maxDate"
                            readonly
                          />

                          <mat-datepicker-toggle
                            matSuffix
                            [for]="quotedDateDatepicker"
                            [disabled]="false"
                          ></mat-datepicker-toggle>

                          <mat-datepicker
                            #quotedDateDatepicker
                          ></mat-datepicker>
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label
                            >Price Good Until<span
                              class="required-star"
                              style="color: red; margin-left: 2px"
                              >*</span
                            ></mat-label
                          >
                          <input
                            matInput
                            name="priceGoodUntilDate"
                            formControlName="priceGoodUntilDate"
                            [matDatepicker]="priceGoodUntilDateDatepicker"
                            [min]="minDate"
                          />

                          <mat-datepicker-toggle
                            matSuffix
                            [for]="priceGoodUntilDateDatepicker"
                            [disabled]="false"
                          ></mat-datepicker-toggle>

                          <mat-datepicker
                            #priceGoodUntilDateDatepicker
                          ></mat-datepicker>
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label
                            >Offered quality<span
                              class="required-star"
                              style="color: red; margin-left: 2px"
                              >*</span
                            ></mat-label
                          >
                          <mat-select formControlName="offeredQuality">
                            <mat-option
                              *ngFor="let item of offeredQualityData"
                              [value]="item.id"
                            >
                              {{ item.qualityDescription }}</mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label
                            >For on-time service completion<span
                              class="required-star"
                              style="color: red; margin-left: 2px"
                              >*</span
                            ></mat-label
                          >
                          <input
                            matInput
                            name="onTimeDeliveryOrderDate"
                            formControlName="onTimeDeliveryOrderDate"
                            [matDatepicker]="
                              onTimeDeliveryOrderDateDateDatepicker
                            "
                            [min]="minDate"
                          />

                          <mat-datepicker-toggle
                            matSuffix
                            [for]="onTimeDeliveryOrderDateDateDatepicker"
                            [disabled]="false"
                          ></mat-datepicker-toggle>

                          <mat-datepicker
                            #onTimeDeliveryOrderDateDateDatepicker
                          ></mat-datepicker>
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Quoted Delivery In Days</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="quotedDeliveryInDays"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div class="header-form">
                    <span
                      style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      "
                      (click)="toggleVisibility('form2')"
                    >
                      Incoterms Details
                      <mat-icon>
                        {{ isForm2Expand ? "minimize" : "add" }}
                      </mat-icon>
                    </span>

                    <div *ngIf="isForm2Expand" class="three-column-flex">

                      <div class="form-item-row">
                        <mat-form-field appearance="fill" class="full-width">
                          <mat-label>Incoterm</mat-label>

                          <mat-select
                            formControlName="incoterms"
                            (selectionChange)="onIncotermSelected($event.value)"
                          >
                            <mat-option
                              *ngFor="let item of incoterms"
                              [value]="item.id"
                            >
                              {{ item.incotermCode }}</mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="form-item-row">
                        <mat-form-field appearance="fill" class="full-width">
                          <mat-label>Incoterm Locations</mat-label>

                          <input
                            matInput
                            [formControl]="countryControl"
                            [matAutocomplete]="auto"
                            (ngModelChange)="onInputChange($event)"
                            placeholder="Select Countries"
                          />

                          <mat-autocomplete
                            #auto="matAutocomplete"
                            autoActiveFirstOption="false"
                            panelClass="custom-autocomplete-panel"
                          >
                            <mat-option
                              *ngFor="let country of filteredCountries"
                              [value]="null"
                              class="no-selection"
                            >
                              <mat-checkbox
                                [checked]="isCountrySelected(country)"
                                (change)="onCheckboxChange($event, country)"
                                class="yellow-checkbox"
                              >
                                {{ country.name }}
                              </mat-checkbox>
                            </mat-option>
                          </mat-autocomplete>

                          <mat-hint
                            *ngIf="selectedCountries.length"
                            style="font-weight: bold; margin-top: 8px"
                          >
                            {{ getSelectedCountries() }}
                          </mat-hint>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div class="header-form">
                    <span
                      style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      "
                      (click)="toggleVisibility('form3')"
                    >
                      My Details
                      <mat-icon>
                        {{ isForm3Expand ? "minimize" : "add" }}
                      </mat-icon>
                    </span>

                    <div *ngIf="isForm3Expand" class="three-column-flex">
                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Contact Name</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="supplierContactName"
                            readonly
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Email Address</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="supplierEmail"
                            readonly
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Telephone Number</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="supplierTelephone"
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Mobile Number</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="supplierMobile"
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Company Email</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="supplierCompanyEmail"
                          />
                        </mat-form-field>
                      </div>

                    </div>
                  </div>

                  <div class="header-form">
                    <span
                      style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      "
                      (click)="toggleVisibility('form4')"
                    >
                      Buyer Comment & Attachments
                      <mat-icon>
                        {{ isForm4Expand ? "minimize" : "add" }}
                      </mat-icon>
                    </span>

                    <div
                      *ngIf="isForm4Expand"
                      style="
                        margin-top: 32px;
                        display: flex;
                        gap: 10px;
                        justify-content: flex-start;
                        align-items: center;
                      "
                    >
                      <div style="display: flex; width: 100%">
                        <div class="buyer-comment" style="flex: 1">
                          <mat-form-field class="full-width" color="accent">
                            <mat-label>Buyer Comment</mat-label>
                            <textarea
                              matInput
                              placeholder=""
                              formControlName="buyerComment"
                              readonly
                            ></textarea>
                          </mat-form-field>
                        </div>

                        <div
                          style="display: flex; align-items: center; flex: 1"
                          class="file-name-box"
                        >
                          <span>
                            {{
                              buyerAttachmentUrl.length === 0
                                ? "No files attached"
                                : buyerAttachmentUrl.length === 1
                                ? "1 file attached"
                                : buyerAttachmentUrl.length + " files attached"
                            }}
                          </span>

                          <button
                            mat-icon-button
                            *ngIf="buyerAttachmentUrl.length > 0"
                            (click)="toggleBuyerAttachments(true)"
                            type="button"
                          >
                            <mat-icon>visibility</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-form">
                    <span
                      style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      "
                      (click)="toggleVisibility('form5')"
                    >
                      Supplier Comment & Attachments
                      <mat-icon>
                        {{ isForm5Expand ? "minimize" : "add" }}
                      </mat-icon>
                    </span>

                    <div
                      *ngIf="isForm5Expand"
                      style="
                        margin-top: 32px;
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        gap: 10px;
                        padding: 0 16px;
                      "
                    >

                      <div style="grid-row: 1 / 3">
                        <mat-form-field class="full-width" color="accent" style="height: 100%">
                          <mat-label>Supplier Comment</mat-label>
                          <textarea
                            matInput
                            placeholder=""
                            formControlName="supplierComment"
                          ></textarea>
                        </mat-form-field>
                      </div>

                      <!-- Row 1, Column 2: Drag & Drop -->
                      <div
                        class="drag-suppplier-file"
                        style="max-width: none; margin: 0; width: 100%; box-sizing: border-box"
                        (click)="toggleSidebar(true, 'attachment')"
                      >
                        <mat-icon class="upload-icon">cloud_upload</mat-icon>
                        <p class="drag-drop-text">Drag & drop the file here or</p>
                        <div class="upload-text">
                          <p class="upload-link">upload a file</p>
                        </div>
                        <p class="file-type-info">*PDF, JPG or PNG</p>
                      </div>


                      <div
                        style="display: flex; align-items: center; box-sizing: border-box; margin: 0"
                        class="file-name-box"
                      >
                        <span>
                          {{
                            !firstFormGroup.get('quoteHeaderAttachments')?.value ||
                            firstFormGroup.get('quoteHeaderAttachments')?.value?.length === 0
                              ? "No files attached"
                              : firstFormGroup.get('quoteHeaderAttachments')?.value?.length === 1
                              ? "1 file attached"
                              : firstFormGroup.get('quoteHeaderAttachments')?.value?.length +
                                " files attached"
                          }}
                        </span>

                        <button
                          mat-icon-button
                          *ngIf="firstFormGroup.get('quoteHeaderAttachments')?.value?.length > 0"
                          (click)="toggleSupplierAttachments(true)"
                          type="button"
                        >
                          <mat-icon>visibility</mat-icon>
                        </button>
                      </div>

                      <div class="form-item-row">
                        <div class="full-width" style="margin-bottom: 30px">
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- <div class="header-form">
                    <span
                      style="
                        padding-left: 16px;
                        padding-top: 16px;
                        margin-bottom: 32px;
                        font-weight: bold;
                        display: flex;
                        justify-content: space-between;
                        padding-right: 20px;
                      "
                      (click)="toggleVisibility('form6')"
                    >
                      Freight Forwarder Details
                      <mat-icon>
                        {{ isForm6Expand ? "minimize" : "add" }}
                      </mat-icon>
                    </span>

                    <div *ngIf="isForm6Expand" class="three-column-flex">
                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Freight Forwarder Company Name</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="freightForwarderCompanyName"
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>PIC</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="pic"
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Job Title</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="freightForwarderJobTitle"
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Email Id</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="freightForwarderEmailId"
                            maxlength="255"
                            pattern="^([a-zA-Z0-9_\-\.\+]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,})$"
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Phone</mat-label>
                          <input
                            matInput
                            name="freightForwarderPhone"
                            formControlName="freightForwarderPhone"
                            placeholder="Phone"
                            maxlength="25"
                            onkeypress="return event.charCode >= 32 && event.charCode <= 64 ||  event.charCode >= 91 && event.charCode <= 96 ||  event.charCode >= 123 && event.charCode <= 126"
                          />
                        </mat-form-field>
                      </div>
                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Fax</mat-label>
                          <input
                            matInput
                            name="freightForwarderFax"
                            formControlName="freightForwarderFax"
                            placeholder="Fax"
                            maxlength="25"
                            onkeypress="return event.charCode >= 32 && event.charCode <= 64 ||  event.charCode >= 91 && event.charCode <= 96 ||  event.charCode >= 123 && event.charCode <= 126"
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Address</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="freightForwarderAddress"
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Packaging</mat-label>
                          <input
                            matInput
                            placeholder=""
                            formControlName="packaging"
                          />
                        </mat-form-field>
                      </div>

                      <div class="form-item-row">
                        <mat-form-field class="full-width" color="accent">
                          <mat-label>Mode of Transport</mat-label>
                          <mat-select formControlName="modeOfTransport">
                            <mat-option value="maritime"> Maritime</mat-option>
                            <mat-option value="rail"> Rail</mat-option>
                            <mat-option value="road"> Road</mat-option>
                            <mat-option value="air"> Air</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div> -->
                </div>
              </form>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- add new document -->
      <div
        class="attachmentSidebar"
        style="overflow: auto"
        *ngIf="showAddDocumentSection"
      >
        <div
          class="sidebar-title"
          style="justify-content: space-between; padding: 15px 15px"
        >
          <div class="sidebar-title-text">Add New Document</div>
          <div
            style="display: flex; justify-content: right; width: 50%; gap: 10px"
          >
            <span
              style="float: right"
              class="pointer header-close-btn"
              matTooltipClass="mat-tooltip-custom"
              matTooltip="Close"
              matTooltipPosition="below"
              (click)="toggleSidebar(false, 'attachment')"
            >
              <mat-icon style="color: white">close</mat-icon>
            </span>
          </div>
        </div>

        <div class="sidebar-content" style="padding-top: 10px">
          <mat-form-field class="full-width" color="accent">
            <mat-label>Document Type</mat-label>
            <mat-select [(ngModel)]="selectedAttachmentType">
              <mat-option
                *ngFor="let item of headerAttachmentType"
                [value]="item.id"
              >
                {{ item.documentTypeDescription }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <ngx-file-drop
            class="w100 file-drop-zone"
            dropZoneLabel="Drop files here"
            (onFileDrop)="onAttachmentChange($event)"
            (onFileOver)="fileOver($event)"
            (onFileLeave)="fileLeave($event)"
            accept=".svg,.SVG,.png,.PNG,.jpeg,.JPEG,.jpg,.JPG,.pdf,.PDF"
          >
            <ng-template
              style="display: flex; flex-direction: row"
              ngx-file-drop-content-tmp
              let-openFileSelector="openFileSelector"
            >
              <div class="drag-file">
                <mat-icon>cloud_upload</mat-icon>
                <p>Drag & drop the file here or</p>
                <div class="" (click)="openFileSelector()">
                  <p style="color: #74c5b5">upload a file</p>
                </div>
                <p>*PDF, JPG or PNG</p>
              </div>
            </ng-template>
          </ngx-file-drop>

          <div
            *ngIf="firstFormGroup.get('quoteHeaderAttachments')?.value"
            style="display: flex; flex-direction: column"
          >
            <h3 style="padding-top: 20px">Header Attachments</h3>
            <div
              class="file-name-box"
              *ngFor="
                let file of firstFormGroup.get('quoteHeaderAttachments')?.value
              "
            >
              {{ file.name }}
              <div *ngIf="file.attachmentId && file.attachmentId != null">
                <button
                  mat-icon-button
                  matTooltipClass="mat-tooltip-custom"
                  matTooltip="View"
                  matTooltipPosition="below"
                  (click)="downloadDocument(file.url)"
                >
                  <mat-icon>download</mat-icon>
                </button>

                <button
                  mat-icon-button
                  matTooltipClass="mat-tooltip-custom"
                  matTooltip="Delete"
                  matTooltipPosition="below"
                  (click)="removeAttachment(file)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div class="button-container">
            <button
              type="button"
              class="save-button"
              (click)="saveAttachment()"
            >
              <mat-icon>save</mat-icon>
            </button>
            <button
              type="button"
              class="close-button"
              (click)="toggleSidebar(false, 'attachment')"
            >
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Popup for decline confirmation -->
<div class="namemodal" *ngIf="showDeclineConfirmationDialogue">
  <div class="modalContent">
    <div class="p-6 text-center">
      <div class="flex justify-center mb-4">
        <div
          class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
        >
          <mat-icon
            class="text-orange-600"
            style="font-size: 40px; height: 100%; width: 100%"
            >warning</mat-icon
          >
        </div>
      </div>
      <h2 class="text-xl font-bold mb-2">Are you sure?</h2>
      <p class="mb-6">
        Are you sure you want to decline this request for quotation?<br />Select
        a reason from the dropdown
      </p>
      <mat-form-field class="full-width" color="accent">
        <mat-label>Decline reason</mat-label>
        <mat-select [(ngModel)]="declineReason">
          <mat-option value="Price is too high"> Price is too high</mat-option>
          <mat-option value="Unable to meet specifications">
            Unable to meet specifications</mat-option
          >
          <mat-option value="Not available at this time">
            Not available at this time</mat-option
          >
          <mat-option value="No capacity to fulfill the order">
            No capacity to fulfill the order</mat-option
          >
          <mat-option value="Conflict of interest">
            Conflict of interest</mat-option
          >
          <mat-option value="Other"> Other</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="flex justify-center gap-4">
        <button
          mat-raised-button
          color="primary"
          (click)="declineRfq()"
          [disabled]="declineReason == ''"
        >
          Yes, Decline
        </button>
        <button mat-stroked-button (click)="cancelDecline()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- Popup for close/draft confirmation -->
<div class="namemodal" *ngIf="showCloseDialogue">
  <div class="modalContent">
    <div class="p-6 text-center">
      <div class="flex justify-center mb-4">
        <div
          class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
        >
          <mat-icon
            class="text-orange-600"
            style="font-size: 40px; height: 100%; width: 100%"
            >warning</mat-icon
          >
        </div>
      </div>
      <p class="mb-6">You want to save this as draft?</p>
      <div class="flex justify-center gap-4">
        <button
          mat-raised-button
          color="primary"
          (click)="save(true)"
          style="margin-right: 5px"
        >
          YES
        </button>
        <button mat-stroked-button (click)="cancel()" style="margin-left: 5px">
          NO
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="blur"
  *ngIf="supplierAttachmentsSection"
  (click)="toggleSupplierAttachments(false)"
></div>
<div class="carousel-container" *ngIf="supplierAttachmentsSection">
  <div
    class="carousel-close-button"
    style="display: flex; flex-direction: row; gap: 10px"
  >
    <button
      class="image-download-button"
      *ngIf="supplierAttachmentUrls.length > 0"
      (click)="downloadDocument(supplierAttachmentUrls[supplierCurrentIndex])"
    >
      <mat-icon style="font-size: 20px">download</mat-icon>
    </button>

    <button class="image-close-button" (click)="toggleSupplierAttachments(false)">
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <button class="carousel-control prev" (click)="prevSupplierSlide()">
      &#10094;
    </button>

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(supplierAttachmentUrls[supplierCurrentIndex])"
      >
        <pdf-viewer
          [src]="supplierAttachmentUrls[supplierCurrentIndex]"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(supplierAttachmentUrls[supplierCurrentIndex])"
      >
        <img
          [src]="supplierAttachmentUrls[supplierCurrentIndex]"
          [alt]="'supplier attachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <button class="carousel-control next" (click)="nextSupplierSlide()">
      &#10095;
    </button>
  </div>
</div>

<div
  class="blur"
  *ngIf="paymentTermsAndConditionsSection"
  (click)="togglePaymentTermsAndConditionsAttachment(false)"
></div>
<div class="carousel-container" *ngIf="paymentTermsAndConditionsSection">
  <div class="carousel-close-button">
    <button
      class="image-close-button"
      (click)="togglePaymentTermsAndConditionsAttachment(false)"
    >
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <pdf-viewer
          [src]="paymentTermsAndConditionAttachmentUrl"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(paymentTermsAndConditionAttachmentUrl)"
      >
        <img
          [src]="paymentTermsAndConditionAttachmentUrl"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

  </div>
</div>

<div
  class="blur"
  *ngIf="buyerAttachmentsSection"
  (click)="toggleBuyerAttachments(false)"
></div>
<div class="carousel-container" *ngIf="buyerAttachmentsSection">
  <div
    class="carousel-close-button"
    style="display: flex; flex-direction: row; gap: 10px"
  >
    <button
      class="image-download-button"
      *ngIf="buyerAttachmentUrl.length > 0"
      (click)="downloadDocument(buyerAttachmentUrl[currentIndex])"
    >
      <mat-icon style="font-size: 20px">download</mat-icon>
    </button>

    <button class="image-close-button" (click)="toggleBuyerAttachments(false)">
      <mat-icon style="font-size: 20px">cancel</mat-icon>
    </button>
  </div>
  <div class="carousel">
    <button class="carousel-control prev" (click)="prevSlide()">
      &#10094;
    </button>

    <div class="carousel-image-container">
      <div
        class="headerattachmentcarouselimageContainerInner"
        *ngIf="isPdf(buyerAttachmentUrl[currentIndex])"
      >
        <pdf-viewer
          [src]="buyerAttachmentUrl[currentIndex]"
          [render-text]="false"
          [page]="1"
          [show-all]="true"
          [original-size]="false"
          class="content"
        >
        </pdf-viewer>
      </div>
      <div
        class="headerattachmentimage-container-inner"
        *ngIf="!isPdf(buyerAttachmentUrl[currentIndex])"
      >
        <img
          [src]="buyerAttachmentUrl[currentIndex]"
          [alt]="'headerattachment image'"
          class="carousel-image"
        />
      </div>
    </div>

    <button class="carousel-control next" (click)="nextSlide()">
      &#10095;
    </button>
  </div>
</div>

<!-- Notification Overlay to Dim the Background -->
<div *ngIf="showNotification" class="notification-overlay"></div>

<!-- Custom Notification for Missing Fields -->
<div
  *ngIf="showNotification"
  class="notification-popup"
  [ngClass]="{
    'error-notification': notificationType === 'error',
    'info-notification': notificationType === 'info',
    show: showNotification,
    hide: !showNotification
  }"
>
  <div class="notification-content">
    <div class="flex justify-center mb-4">
      <div
        class="bg-orange-100 rounded-full w-20 h-20 flex items-center justify-center"
      >
        <mat-icon
          class="text-orange-600"
          style="font-size: 75px; height: 100%; width: 100%"
          >warning</mat-icon
        >
      </div>
    </div>
    <div class="notification-message" [innerHTML]="notificationMessage"></div>
    <button (click)="dismissNotification()" class="btn-ok">OK</button>
  </div>
</div>
